/**
 * German (Germany) locale settings for Webix.
 */
webix.i18n.locales['de-DE'] = {
    groupDelimiter: '.', // Delimiter for groups of thousands
    groupSize: 3, // Size of groups of thousands
    decimalDelimiter: ',', // Delimiter for decimal part
    decimalSize: 2, // Number of decimal places
    dateFormat: '%d.%n.%Y', // Date format
    timeFormat: '%H:%i', // Time format
    longDateFormat: '%j. %F %Y', // Long date format
    fullDateFormat: '%j. %F %Y %H:%i', // Full date and time format
    am: null, // AM marker (not used in this locale)
    pm: null, // PM marker (not used in this locale)
    price: '{obj} €', // Price format
    priceSettings: {
        groupDelimiter: '.', // Delimiter for groups of thousands in prices
        groupSize: 3, // Size of groups of thousands in prices
        decimalDelimiter: ',', // Delimiter for decimal part in prices
        decimalSize: 2, // Number of decimal places in prices
    },
    calendar: {
        monthFull: [
            'Januar',
            'Februar',
            'März',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember',
        ], // Full names of months
        monthShort: ['Jan', 'Feb', 'Mrz', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'], // Short names of months
        dayFull: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'], // Full names of days
        dayShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'], // Short names of days
        hours: 'Stunden', // Label for hours
        minutes: 'Minuten', // Label for minutes
        done: 'Fertig', // Label for done button
        clear: 'Entfernen', // Label for clear button
        today: 'Heute', // Label for today button
    },
    dataExport: {
        page: 'Seite', // Label for page
        of: 'aus', // Label for of
    },
    PDFviewer: {
        of: 'aus', // Label for of
        automaticZoom: 'Automatisch Zoom', // Label for automatic zoom
        actualSize: 'Aktuelles Ausmaß', // Label for actual size
        pageFit: 'Seite Ausmaß', // Label for page fit
        pageWidth: 'Seite Breite', // Label for page width
        pageHeight: 'Seite Höhe', // Label for page height
    },
    aria: {
        calendar: 'Kalender', // ARIA label for calendar
        increaseValue: 'Wert erhöhen', // ARIA label for increase value
        decreaseValue: 'Wert verringern', // ARIA label for decrease value
        navMonth: ['Vorheriger Monat', 'Nächsten Monat'], // ARIA labels for navigating months
        navYear: ['Vorheriges Jahr', 'Nächstes Jahr'], // ARIA labels for navigating years
        navDecade: ['Zurück Jahrzehnt', 'Als nächstes Jahrzehnt'], // ARIA labels for navigating decades
        dateFormat: '%j. %F %Y', // ARIA date format
        monthFormat: '%F %Y', // ARIA month format
        yearFormat: '%Y', // ARIA year format
        hourFormat: 'Stunden: %H', // ARIA hour format
        minuteFormat: 'Minuten: %i', // ARIA minute format
        removeItem: 'Element entfernen', // ARIA label for removing item
        pages: ['Erste Seite', 'Vorherige Seite', 'Folgeseite', 'Letzte Seite'], // ARIA labels for pages
        page: 'Seite', // ARIA label for page
        headermenu: 'Titelmenü', // ARIA label for header menu
        openGroup: 'Öffnen Spaltengruppe', // ARIA label for opening column group
        closeGroup: 'Schließen Spaltengruppe', // ARIA label for closing column group
        closeTab: 'Tab schließen', // ARIA label for closing tab
        showTabs: 'Weitere Tabs', // ARIA label for showing more tabs
        resetTreeMap: 'Zurück zur ursprünglichen Ansicht', // ARIA label for resetting tree map
        navTreeMap: 'Aufleveln', // ARIA label for navigating tree map
        nextTab: 'Weiter tab', // ARIA label for next tab
        prevTab: 'Zurück tab', // ARIA label for previous tab
        multitextSection: 'Element hinzufügen', // ARIA label for adding element
        multitextextraSection: 'Element entfernen', // ARIA label for removing element
        showChart: 'Chart anzeigen', // ARIA label for showing chart
        hideChart: 'Chart verstecken', // ARIA label for hiding chart
        resizeChart: 'Chart Größe ändern', // ARIA label for resizing chart
    },
    richtext: {
        underline: 'Unterstreichen', // Label for underline
        bold: 'Fettgedruckt', // Label for bold
        italic: 'Kursiv', // Label for italic
    },
    combo: {
        select: 'Auswählen', // Label for select
        selectAll: 'Alles auswählen', // Label for select all
        unselectAll: 'Alles widerrufen', // Label for unselect all
    },
};

// FILE DOCUMENTED
